/** Textes « contrats » — le français fait foi. */
export const contrats = {
  filtres: { actif: 'En cours', clos: 'Terminés', resilie: 'Résiliés', tous: 'Tous' },
  titre: 'Contrats',
  sousTitre: 'Tous vos contrats signés · retrouvez-en un et réimprimez-le',
  recherche: 'N° de contrat, client, marque ou plaque…',
  aucunCorrespond: 'Aucun contrat ne correspond',
  aucunIci: 'Aucun contrat ici',
  essayez: 'Essayez avec la plaque, le nom du client, ou changez de filtre.',
  explication: "Un contrat est édité depuis le dossier d'une location, au moment du départ. Changez de filtre pour voir les contrats terminés.",
  resteDu: (m: string) => `Reste dû ${m}`,
  solde: (m: string) => `Soldé · ${m}`,
  imprimerContrat: 'Imprimer le contrat',
  colNumero: 'N° contrat', colDate: 'Date', colClient: 'Client', colVehicule: 'Véhicule',
  colTotal: 'Total', colResteDu: 'Reste dû', colStatut: 'Statut',
  imprimer: 'Imprimer',
  pied: (n: number, total: number | null) =>
    `${n} contrat(s) affiché(s)${total !== null ? ` sur ${total}` : ''}. Un contrat imprimé est identique à l'original, même des mois après — il est inaltérable.`,
};
